import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// react-router does not scroll to #hash targets on its own. Depending on
// `key` (not just `hash`) re-scrolls when the same anchor is clicked twice.
export function useHashScroll() {
    const { hash, key } = useLocation();

    useEffect(() => {
        if (!hash) {
            window.scrollTo(0, 0);
            return;
        }
        const target = document.getElementById(decodeURIComponent(hash.slice(1)));
        if (!target) return;

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
    }, [hash, key]);
}
